module.exports = __webpack_public_path__ + "img/good3.76b92139.jpg";